module.exports = __webpack_public_path__ + "img/black.57272347.svg";